// 企业认证相关接口封装
import request from './request'

// 1. 获取企业列表
export const getCompanyList = (data) =>
    request({
        url: '/api/login/business/verify/submit',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        },
    })

// 2. 确认企业信息并初始化人脸核身
export const confirmCompanyAndInitFace = (data) =>
    request({
        url: '/api/login/business/verify/confirm',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'application/json'
        },
    })

    //轮询人脸核身结果api/face/scan/status
export const queryFaceScanStatus = (params) =>
    request({
        url: '/api/face/scan/status',
        method: 'get',
        params,

    })

// 3. 查询人脸核身结果
export const queryFaceVerificationResult = (params) =>
    request({
        url: '/api/face/query',
        method: 'get',
        params,

    })
/* export const queryFaceVerificationResult = (params) =>
    request({
        url: '/api/face-verification/query?certifyId='+params.certifyId,
        method: 'get',
        params,

    }) */

// 4. 绑定企业信息
export const bindCompanyInfo = (data) =>
    request({
        url: '/api/login/business/verify/relation',
        method: 'post',
        data,

    })